const AboutPage = ({ data, lang }) => {
    console.log("AboutPage data", data)
    return (
        <div className="container">
            <div className="about-text f24 d-flex align-items-center justify-content-center mt-5">
                <span className="color10 f32 fw500">{data?.description[lang]}</span>
            </div>
            <div className="about1 mt-5 mb-5 f17 fw500 color1">
                <div dangerouslySetInnerHTML={{ __html: data?.content[lang] }}></div>
            </div>
        </div>
    )
}

export default AboutPage
